import { render } from "./Aco.vue?vue&type=template&id=c3dfed5c"
import script from "./Aco.vue?vue&type=script&lang=js"
export * from "./Aco.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\kensi\\Documents\\Git-clone\\みんなのdx研究会\\dx_study_group.git\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__